import styled from 'styled-components'

const WrapPlaceHolder = styled.div`
display:flex;
width:100%;
column-gap: 20px;
`

export { WrapPlaceHolder }